import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import type { Draft } from "immer";
import { ApiEndpoints, baseQueryWithAuth } from "../../../core";

interface ApiResponse<T = any> {
  success: boolean;
  message: string;
  result?: T;
  results?: T;
}

export const equipmentApi = createApi({
  reducerPath: "equipmentApi",
  baseQuery: baseQueryWithAuth,
  tagTypes: ["Equipments"],

  endpoints: (builder) => ({
    getEquipment: builder.query<any, { limit: number }>({
      query: ({  limit }) => ({
        url: `${ApiEndpoints.getAllEquipments}?limit=${limit}`,
        method: "GET",
      }),
      providesTags: ["Equipments"],
    }),
  }),
});

export const { useGetEquipmentQuery } = equipmentApi;
